import { request } from "./request";
import qs from "qs";
export function getProjectList(id, offset, limit, deleted_status) {
  return request({
    url: 'project/limit',//获取项目接口
    params: {
      userId: id,
      offset: offset,
      limit: limit,
      deleted_status: deleted_status,
    }
  });
}
export function getProjectDetail(projectId) {
  return request({
    url: "project/detail", //详细信息接口
    params: {
      id: projectId,
    },
  });
}
export function deleteProject(id) {
  var data = {
    projectId: id,
  };
  return request({
    url: "project/delete1", //删除项目接口
    data: qs.stringify(data),
    method: "post",
  });
}
export function removeDataFile(fileName) {
  let data = {
    fileName: fileName
  }
  return request({
    url: 'project/remove/dataFile',
    data: qs.stringify(data),
    method: 'post'
  })
}
export function batchDeleteProject(idList, deleted_status) {
  var data = {
    projectIds: idList.join(','),
    deleted_status: deleted_status,
  };
  return request({
    url: "project/delete1", //删除项目接口
    data: qs.stringify(data),
    method: "post",
  });
}
export function batchDeleteProject_1(idList) {
  var data = {
    projectIds: idList.join(','),
  };
  return request({
    url: "project/delete1_1", //删除项目接口
    data: qs.stringify(data),
    method: "post",
  });
}
export function isProjectExist(name) {
  return request({
    url: "/project/name/exist", //项目名称重复接口
    params: {
      projectName: name,
    },
  });
}
export function createProject(pro) {
  return request({
    url: "/project/new", //创建项目接口
    headers: { "Content-Type": "application/json" },
    data: pro,
    method: "post",
  });
}
export function startFullModelAna() {
  return request({
    url: "/full/start", //开始全模型分析接口
    timeout: 50000
  });
}

// cfa模型
export function startCfaModelAna() {
  return request({
    url: "/cfa/do", //开始cfa分析接口
  });
}
export function getCfaRateApi() {
  return request({
    url: "/model/cfa/rate", //获取cfaRate接口
  });
}
export function getCfaResultApi() {
  return request({
    url: "/cfa/result", //获取cfa报告接口
  });
}

export function getCfaFitIndexApi() {
  return request({
    url: "/cfa/fit/index", //获取cfa拟合指数接口
  });
}
export function getCfaResultPicApi(modelId) {
  return request({
    url: "/img/resultpic/" + modelId + ".png", //获取cfa图片接口
  });
}

//full模型
export function getFullRateApi() {
  return request({
    url: "/model/full/rate", //获取cfaRate接口
  });
}
export function getFullModelIdsApi(params) {
  return request({
    url: "/model/full/models", //获取全模型接口
    method: "get",
    params: params,
    paramsSerializer: params => { return qs.stringify(params, { indices: false }) }
  })
}

// export function getFullResultPicApi(id) {
//   return request({
//     url: "/img/resultpic/" + id + ".png", //获取全模型图片接口
//   });
// }
export function getPotentialsApi() {
  return request({
    url: "/model/potentials", //全模型分析获取潜在变量接口
  });
}
export function getOptResultApi(r) {
  var data = {
    rank: r,
  }
  return request({
    url: "/model/full/bid", //获取最优全模型结果接口
    data: qs.stringify(data),
    method: 'post'
  });
}
export function getFullFitIndexApi(r, uid) {
  return request({
    url: "/model/full/fitIndex", //获取全模型拟合指数接口
    params: {
      userId: uid,
      rank: r,
    },
    method: 'post'
  });
}
export function searchFullIdsApi(r) {
  var data = {
    relation: r,
  }
  return request({
    url: "/model/search/full/models", //搜索全模型结果接口
    data: qs.stringify(data),
    method: 'post'
  });
}

export function uploadFileApi(file) {
  return request({
    url: "/upload", //上传数据文件接口
    headers: { "Content-Type": "multipart/form-data" },
    data: file,
    method: "post",
  });
}

export function uploadFileApiV2(file) {
  return request({
    url: "/upload/v2", //上传数据文件接口
    headers: { "Content-Type": "multipart/form-data" },
    data: file,
    method: "post",
  });
}

export function downloadReportApi(id, isEn) {
  return request({
    url: "/download/report", //下载分析报告文件接口
    params: {
      modelId: id,
      isEn: isEn
    },
    responseType: 'blob'
  });
}
export function downloadSampleApi(n) {
  return request({
    url: "/download/sample", //下载样例接口
    params: {
      fileNum: n,
    },
    responseType: 'blob'
  });
}


